// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/css/animate.css
// module id = 19
// module chunks = 0